<template>
<div>
    <novin-logo v-if="row.psp == 'novin'"/>
    <parsian-logo v-if="row.psp == 'parsian'"/>
    <pasargad-logo v-if="row.psp == 'pasargad'"/>
    <saman-logo v-if="row.psp == 'saman'"/>
    <sepehr-logo v-if="row.psp == 'sepehr'"/>
    <mellat-logo v-if="row.psp == 'mellat'"/>
    <ap-logo v-if="row.psp == 'asanpardakht'"/>
    <iran-kish-logo v-if="row.psp == 'irankish'"/>
    <paystar-logo v-if="row.psp == 'paystar'"/>
</div>
</template>

<script>
import Vue from 'vue'
import { novinLogo, parsianLogo, pasargadLogo, samanLogo,sepehrLogo,mellatLogo, apLogo, iranKishLogo, paystarLogo } from './psp_logos'


export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    components :{
        novinLogo,
        parsianLogo,
        pasargadLogo,
        samanLogo,
        sepehrLogo,
        mellatLogo,
        apLogo,
        iranKishLogo,
        paystarLogo,
    },
    computed: {
    }
})
</script>

<style>

</style>